import React, { FC, ReactElement } from "react";

import { Alert } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { RelativeDate } from "../../../components/Date";
import Link from "../../../components/styled/Link";
import { EntityInfo } from "../../../store/pomeriumApi";

type AttachedRoutesRowProps = {
  id: string;
  name: string;
  updatedAt: string;
  enforced: boolean;
};
const AttachedRoutesRow: FC<AttachedRoutesRowProps> = ({
  id,
  name,
  updatedAt,
  enforced,
}) => {
  return (
    <TableRow
      key={"routeRow" + id}
      sx={{
        "&:last-child td": {
          borderBottom: "none !important",
        },
      }}
    >
      <TableCell>
        <Link to={`/app/management/routes/${id}/edit`}>{name}</Link>
      </TableCell>
      <TableCell>{enforced ? "Inherited" : "Assigned"}</TableCell>
      <TableCell align="center">
        <RelativeDate timestamp={updatedAt} />
      </TableCell>
    </TableRow>
  );
};

interface AttachedRoutesProps {
  routes: EntityInfo[];
  enforcedRoutes: EntityInfo[];
}
const AttachedRoutes = ({
  routes,
  enforcedRoutes,
}: AttachedRoutesProps): ReactElement => {
  if (!routes?.length && !enforcedRoutes?.length) {
    return (
      <Alert severity="info" variant="outlined" sx={{ mt: 2 }}>
        No Routes Use This Policy.{" "}
        <Link to={`/app/management/routes`}>Attach a Route</Link>.
      </Alert>
    );
  }

  return (
    <TableContainer sx={{ pt: 2, pb: 2 }}>
      <Table size="small" aria-label="Attached Routes">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell align="center">Last Updated</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {routes?.map((r) => (
            <AttachedRoutesRow
              key={r.id}
              id={r.id}
              name={r.name}
              updatedAt={r.updatedAt}
              enforced={false}
            />
          ))}
          {enforcedRoutes?.map((r) => (
            <AttachedRoutesRow
              key={r.id}
              id={r.id}
              name={r.name}
              updatedAt={r.updatedAt}
              enforced={true}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AttachedRoutes;
